import { ListAccomplishments } from '../../graphql/Query/accomplishment';
import { DeleteAccomplishment } from '../../graphql/Mutation/accomplishment';
import { useMutation, useQuery } from '@apollo/client';
import CustomTable from '@myComponents/CustomTable';

import { handleConfirmCancel, handleError } from '@components/toast';
import { columns } from './columns';

import { useState } from 'react';
import Sidebar from './Sidebar';

const variables = {
  search: {
    q: '',
    page: 1,
    perPage: 10
  }
};

const defaultValues = {
  title: '',
  type: 'EMPTY',
  cover: '',
  status: 'initial',
  quantity: 1
};

const Achievements = () => {
  const { loading, data, refetch } = useQuery(ListAccomplishments, {
    variables
  });
  const [deleteById] = useMutation(DeleteAccomplishment);
  const [valuesForm, setValuesForm] = useState({});
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
    refetch();
  };

  const handleUpdate = ({ e, row }) => {
    e.preventDefault();
    setValuesForm({
      ...row
    });
    toggleSidebar();
  };

  const handleDelete = async ({ e, id }) => {
    e.preventDefault();
    handleConfirmCancel('delete', false, async () => {
      try {
        await deleteById({ variables: { id } });
        refetch();
      } catch (e) {
        handleError(e);
        throw e;
      }
    });
  };

  return (
    <CustomTable
      loading={loading}
      store={data?.listAccomplishments?.docs || []}
      data={{ ...data?.listAccomplishments, docs: undefined }}
      refetch={refetch}
      headerOptions={{
        type: 'add',
        name: 'Crear Logro',
        handle: () => {
          setValuesForm(defaultValues);
          toggleSidebar();
        }
      }}
      variables={variables}
      columns={columns({ handleUpdate, handleDelete })}
      sidebar={
        <Sidebar
          open={sidebarOpen}
          toggleSidebar={toggleSidebar}
          defaultValues={valuesForm}
          handleFetching={refetch}
        />
      }
    />
  );
};

export default Achievements;
